import * as React from "react";

import { cn } from "@/lib/utils";

export type InputSize = "sm" | "md" | "lg";

const sizeClasses: Record<InputSize, string> = {
  sm: "h-9 text-sm",
  md: "h-[40px] text-[14px] leading-[20px]",
  lg: "h-12 text-base",
};

interface HarmonyInputProps extends React.ComponentProps<"input"> {
  fieldSize?: InputSize;
}

const Input = React.forwardRef<HTMLInputElement, HarmonyInputProps>(
  ({ className, type, fieldSize = "md", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base
          "flex w-full rounded-[10px] border border-input bg-background px-3 py-2 shadow-sm transition-colors placeholder:text-muted-foreground text-foreground",
          // Focus (Figma mavi halo)
          // Use CSS outline (not box-shadow ring) so focus indicator is never clipped by overflow:hidden parents
          "focus:outline-2 focus:outline-offset-[-1px] focus:[outline-color:hsl(var(--primary)/0.45)] focus:ring-0 focus:ring-offset-0",
          "focus-visible:outline-2 focus-visible:outline-offset-[-1px] focus-visible:[outline-color:hsl(var(--primary)/0.45)] focus-visible:ring-0 focus-visible:ring-offset-0",
          // Disabled (Figma gri arka plan ve metin)
          "disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:border-border",
          // Invalid (error state) – aria-invalid=true olduğu durumda
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-0 aria-[invalid=true]:focus-visible:ring-offset-0",
          sizeClasses[fieldSize],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
